import { render, staticRenderFns } from "./CarteiraCadastroCamposPersonalizadosApp.vue?vue&type=template&id=6d15c2e1&scoped=true"
import script from "./CarteiraCadastroCamposPersonalizadosApp.vue?vue&type=script&lang=js"
export * from "./CarteiraCadastroCamposPersonalizadosApp.vue?vue&type=script&lang=js"
import style0 from "./CarteiraCadastroCamposPersonalizadosApp.vue?vue&type=style&index=0&id=6d15c2e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d15c2e1",
  null
  
)

export default component.exports